export const radii = {
  xl: '10px',
  '2xl': '20px',
  '3xl': '30px',
  '4xl': '40px',
};
